import update from 'immutability-helper'
import fetch, {createPublic, createPost} from '../helpers/command'
import {shuffleArray} from '../helpers/utils'
import {initQuestion, standardFilters} from '../helpers/quiz'

function whenInPage (pages, fetch) {
  return (context, ...args)  => {
    return pages.indexOf(context.page) >= 0 && fetch(context, ...args)
  }
}

function delayedSetState(defaultDelay, fetch) {
  let timeoutId = 0
  return async (context, options = {}) => {
    const {delay = defaultDelay} = options
    const data = await fetch(context)
    clearTimeout(timeoutId)
    timeoutId = setTimeout(context.setState, delay, {...data})
  }
}

export async function QuizTopics (context) {

  if (context.page != 'quiz' || context.tab != 'assessments') return

  context.updateState({quizTopics: {$set: []}})

  const topics = await fetch('quiz', 'getTopics')()

  context.updateState({quizTopics: {$set: topics}})

}

export function QuizDirectories (context) {
  if ((context.page == 'quiz' && context.tab == 'assessments') || context.page == 'catalogue') {
    delayedSetState(0, fetch('quiz', 'getDirectories', {
      mapParameters: () => ({}),
      mapResponse: data => ({
        quizDirectories: data.reduce((acc, directory)=> {
          acc[directory.id] = {...directory, opened: false}
          return acc
        }, {})
      })
    }))(context)
  }
}

export function QuizAssessments (context) {
  if (context.page == 'quiz' && context.tab == 'assessments') {
    if (context.sectionName == 'standards-search') return
    const quizSearch = update(context.quizSearch, {'assessments': {$set: true}})
    context.setState({quizSearch})
    delayedSetState(0, createPost('quiz', 'searchAssessments', {
      mapParameters: ({query, quizStandardFilters}) => ({...query, ...standardFilters(quizStandardFilters)}),
      mapResponse: results => {
        const [quizPaging, assessments] = results
        const quizAssessments = assessments ? assessments : []
        const quizSearch = update(context.quizSearch, {'assessments': {$set: false}})
        return {quizPaging, quizAssessments, quizSearch}
      }
    }))(context)
  }
}

export function QuizBankAssessments (context) {
  if (context.page == 'quiz' && context.tab == 'assessment-bank') {
    if (context.sectionName == 'standards-search') return
    const quizSearch = update(context.quizSearch, {'assessment-bank': {$set: true}})
    context.setState({quizSearch})
    delayedSetState(0, createPost('quiz', 'searchAssessmentBank', {
      mapParameters: ({query, quizStandardFilters}) => ({...query, ...standardFilters(quizStandardFilters)}),
      mapResponse: results => {
        const [quizPaging, assessments] = results
        const quizBankAssessments = assessments ? assessments : []
        const quizSearch = update(context.quizSearch, {'assessment-bank': {$set: false}})
        return {quizPaging, quizBankAssessments, quizSearch}
      }
    }))(context)
  }
}


export function QuizAssignments (context) {
  if (context.page == 'quiz' && context.tab == 'assigned') {
    if (context.sectionName == 'standards-search') return
    const quizSearch = update(context.quizSearch, {'assigned': {$set: true}})
    context.setState({quizSearch})
    delayedSetState(0, createPost('quiz', 'searchAssignments', {
      mapParameters: ({query, quizStandardFilters}) => ({...query, ...standardFilters(quizStandardFilters)}),
      mapResponse: results => {
        const [quizPaging, assignments] = results
        const quizAssignments = assignments ? assignments : []
        const quizSearch = update(context.quizSearch, {'assigned': {$set: false}})
        return {quizPaging, quizAssignments, quizSearch}
      }
    }))(context)
  }
}



export function QuizAssessment (context) {
  if (context.page == 'quiz' && context.assessment && ['edit','preview'].indexOf(context.action) >= 0) {
    const quizSearch = update(context.quizSearch, {'assessment': {$set: true}})
    const init = initQuestion(context)
    context.setState({quizSearch})
    delayedSetState(0, fetch('quiz', 'getAssessment', {
      mapParameters: ({assessment}) => ({id: assessment}),
      mapResponse: results => {
        const [assessment, sections, questions = []] = results
        const quizAssessment = update(assessment, {course: {$set: (assessment.course || '')}})
        const quizSearch = update(context.quizSearch, {'assessment': {$set: false}})
        const quizQuestions = questions.reduce((acc, question) => {
          acc[question.section] = acc[question.section] || []
          acc[question.section].push(question.initialized ? question : init(question))
          return acc
        }, {})
        const quizSections = sections.map(section=> ({...section, opened: true}))
        return {quizAssessment, quizSections, quizQuestions, quizSearch}
      }
    }))(context)
  }
}

export async function QuizAssessmentToReview (context) {

  if (context.page != 'quiz' || !context.assessment || ['review', 'standards-results'].indexOf(context.action) < 0) return

  context.updateState({quizAssessmentToReview: {}, quizSearch: {'assessment-to-review': {$set: true}}})

  const [assessment] = await fetch('quiz', 'getAssessmentToReview')({id: context.assessment})

  context.updateState({quizAssessmentToReview: {$set: assessment}, quizSearch: {'assessment-to-review': {$set: false}}})

}

export async function QuizAssessmentForPDF (context) {

  if (context.page != 'quiz' || !context.quizAssessmentForPdfId) return

  context.updateState({quizAssessmentForPdf: {}, quizSearch: {'assessment-for-pdf': {$set: true}}})

  const [assessment] = await fetch('quiz', 'getAssessmentToReview')({id: context.quizAssessmentForPdfId})

  context.updateState({quizAssessmentForPdf: {$set: assessment}, quizSearch: {'assessment-for-pdf': {$set: false}}})

}

export async function QuizAssessmentToTake (context) {
  if (context.page != 'quiz' || !context.assessment || context.action != 'take') return
  context.updateState({quizAssessmentToTake: {}, quizSearch: {'assessment-to-take': {$set: true}}})
  const assessment = await searchAssessmentToTake(context.assessment, context)
  context.updateState({quizAssessmentToTake: {$set: assessment}, quizSearch: {'assessment-to-take': {$set: false}}})
}

export async function QuizBlankAssessmentForPDF (context) {
  if (context.page != 'quiz' || !context.quizBlankAssessmentForPdfId) return
  context.updateState({quizBlankAssessmentForPdf: {}, quizSearch: {'blank-assessment-for-pdf': {$set: true}}})
  const assessment = await searchAssessmentToTake(context.quizBlankAssessmentForPdfId, context)
  context.updateState({quizBlankAssessmentForPdf: {$set: assessment}, quizSearch: {'blank-assessment-for-pdf': {$set: false}}})
}

async function searchAssessmentToTake(id, context) {
  const [data] = await fetch('quiz', 'getTestAssessment')({id})
  if (!data || !data.content) return {}
  const assessment = Object.values(data.content.sections).reduce((assessment, section) =>
    section.questions.reduce((assessment, question) =>
      update(assessment, {answers: {[question.id]: {$apply: initAnswer(context.quizQuestionTypes, question)}}})
    , assessment)
  , data)
  return assessment
}

function initAnswer(types, question) {
  const type = types.find(t => t.id == question.type) || {}
  const {defaultStudentAnswer = {}} = type.properties || {}

  function getDefault() {
    if (type.name == 'fill-in-the-blanks') {
      const {phrases = []} = question.answer
      return {phrases: phrases.map(p => p.blanked ? ({blanked: true, phrase: ''}) : p)}
    }
    else if (type.name == 'matching') {
      const {choices = []} = question.answer
      const terms = shuffleArray(choices.map(([term], index) => ({term, index})))
      const definitions = shuffleArray(choices.map(([_,definition], index) => ({definition, index})))
      const selected = terms.map(() => -1)
      return {terms, definitions, selected}
    }
    else if (type.name == 'multiple-choice' && question.properties.shuffle) {
      const {choices = []} = question.answer
      return {selected: null, selectedOptions: [], choices: shuffleArray(choices)}
    }
    return defaultStudentAnswer
  }

  return answer =>
    !answer
      ? {pending: false, completed: false, ...getDefault()} 
      : answer
}


export async function QuizAssignmentAssessments (context) {

  if (context.page != 'quiz' || context.tab != 'assigned') return

  if (!context.assignmentId) return context.updateState({quizStudentAssessments: []})

  context.updateState({quizStudentAssessmentAssignmentId: {$set: undefined}, quizStudentAssessments: {$set: []}, quizSearch: {'student-assessments': {$set: true}}})

  const assessments = await fetch('quiz', 'getAssignmentAssessments')({id: context.assignmentId})

  context.updateState({quizStudentAssessmentAssignmentId: {$set: context.assignmentId}, quizStudentAssessments: {$set: assessments}, quizSearch: {'student-assessments': {$set: false}}})

}

export async function QuizAssessmentResults (context) {

  if (context.page != 'quiz' || !context.assessment || context.action != 'preview-results') return

  context.updateState({quizAssessmentResults: {}, quizSearch: {'assessment-results': {$set: true}}})

  const [assessment] = await fetch('quiz', 'getTestAssessment')({id: context.assessment})

  context.updateState({quizAssessmentResults: {$set: assessment}, quizSearch: {'assessment-results': {$set: false}}})

}


export function QuizQuestionBank (context) {
  const searchingQuestionBank = (context.page == 'quiz' && context.tab == 'question-bank') || context.quizDialogs['search-and-select-question']
  if (searchingQuestionBank) {
    if (context.sectionName == 'standards-search') return
    const quizSearch = update(context.quizSearch, {'question-bank': {$set: true}})
    context.setState({quizSearch})
    delayedSetState(0, createPost('quiz', 'searchQuestionBank', {
      mapParameters: ({query, quizStandardFilters}) => ({...query, ...standardFilters(quizStandardFilters)}),
      mapResponse: results => {
        const [quizPaging, questions] = results
        const quizQuestionBank = questions ? questions.map(initQuestion(context)) : []
        const quizSearch = update(context.quizSearch, {'question-bank': {$set: false}})
        return {quizPaging, quizQuestionBank, quizSearch}
      }
    }))(context)
  }
}

